import { FC } from 'react';
import './HomeNotice.scss';
import { useStyle } from '../../providers/StyleProvider';
import { useAuth } from '../../providers/AuthProvider';

interface HomeNoticeProps { }

const HomeNotice: FC<HomeNoticeProps> = () => {
  const { urlDomus } = useStyle();
  const { tokenLacqua } = useAuth();

  return (
    <main className="HomeNotice main-content mt-0" data-testid="HomeNotice">
      <section>
        <div className="page-header min-vh-100">
          <div className="container">
            <div className="row">
              <div className="col-xl-4 col-lg-5 col-md-7 d-flex flex-column mx-lg-0 mx-auto">
                <div className="card card-plain">
                  <div className="card-body px-lg-5 py-lg-5 text-center">
                    <div className="text-center text-muted mb-4">
                      <h2>Acesso sistema</h2>
                    </div>
                    <div className="row gx-2 gx-sm-3">
                      <p className="text-muted">Para logar no sistema, você precisa acessar o link desejado através do sistema domus.</p>
                    </div>
                    <div className="text-center">
                      <a href={(urlDomus && tokenLacqua) ? `${urlDomus}/app/api/v1/auth/authTokenSB?token=${tokenLacqua}` : `${process.env.REACT_APP_DOMUS_DEV}`}>
                        <button type="button" className="btn btn-primary w-100">Voltar para o login</button>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-6 d-lg-flex d-none h-100 my-auto pe-0 position-absolute top-0 end-0 text-center justify-content-center flex-column">
                <div className="position-relative bg-gradient-primary h-100 m-3 px-7 border-radius-lg d-flex flex-column justify-content-center overflow-hidden" style={{ backgroundImage: `url('https://images.unsplash.com/photo-1506748686214-e9df14d4d9d0?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwzNjUyOXwwfDF8c2VhcmNofDJ8fGdyYWRpZW50JTIwcGxheWVyfGVufDB8fHx8MTY5MjE1NTQ3Ng&ixlib=rb-4.0.3&q=80&w=1080')`, backgroundSize: 'cover' }}>
                  <span className="mask bg-primary opacity-6"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default HomeNotice;
